// import {extent as d3_extent} from 'd3-array'
import { select as d3_select } from 'd3-selection'
import style from 'd3-selection/src/selection/style'
import drawGradientRect from '../utils/drawGradientRect'
import arrowIcon from '../../../assets/icons/icon-chevron-right-grey.svg'
function opacityCheck(parentNode, d, left) {
  let width = parentNode.clientWidth
  let scrollWidth = parentNode.scrollWidth
  if (d === 'left') {
    if (left <= 0) return 0.1
    else return 1
  } else if (d === 'right') {
    if (left >= scrollWidth - width) return 0.1
    else return 1
  }
}
function LegendBehavior($root, chart, config = {}) {
  if (!chart.data) return

  let drawLegend = function (legend, d) {
    // let legendData = d.data
    // A TESTEAR!
    // hide items if the are ALL NULLs
    let legendData = d.data.filter(
      dd =>
        dd.dimensions ||
        (dd.value && (!Array.isArray(dd.value) || !dd.value.every(ddd => ddd.value === null)))
    )
    if (d.type === 'sequential2' || d.type === 'sequential3') {
      let size = { width: 90, height: 15 }

      drawGradientRect(legend.node(), chart.cachedColorScale, size)

      let labels = legend.selectAll('.label').data(['l', 'r'])
      labels = labels.merge(
        labels
          .enter()
          .append('div')
          .attr('class', 'label')
          .each(function (d) {
            d === 'l' && d3_select(this).lower()
          })
      )
      labels.style('margin', '0 5px').style('font-size', '14px')
      labels.text(d => {
        let unit = chart.getUnit()
        return d === 'l'
          ? chart.cachedColorScale.domain()[0]
          : chart.cachedColorScale.domain()[1] + (unit ? ' ' + unit : '')
      })
    } else if (d.type === 'categorical' || d.type === 'categorical2' || d.__forceDraw__) {
      let items = legend.selectAll('.legend-item').data(legendData, d => d.id)
      let itemsEnter = items
        .enter()
        .append('div')
        .attr('class', 'legend-item')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('margin', '5px')

      items.exit().style('opacity', 0).remove()

      itemsEnter.append('div').attr('class', 'icon').style('width', '10px').style('height', '10px')

      itemsEnter.append('div').attr('class', 'label')

      itemsEnter.on('click', (e, d) => {
        chart && chart.emit('labelClick', d)
      })

      items = items.merge(itemsEnter)

      items
        .select('.label')
        .text(d => d.id)
        .style('font-size', '14px')
        .style('width', 'max-content')
      items
        .select('.icon')
        .style('margin', '6px 8px 4px 4px') // este 6px es porque la fuente no esta "bien centrada"
        .transition()
        .style('background', dd => chart.color(dd, d.index))

      let icon = d.data.icon || config.icon
      if (icon === 'circle') {
        items
          .select('.icon')
          .classed('circle', true)
          .style('width', '10px')
          .style('height', '10px')
          .style('border-radius', '10px')
      } else if (icon === 'line') {
        items.select('.icon').classed('rect', true).style('width', '10px').style('height', '2px')
      } else {
        items
          .select('.icon')
          .classed('dented-rect', true)
          .style('width', '10px')
          .style('height', '10px')
        // .style('border-radius', '3px 0 3px 0')
      }
    } else if (d.type === 'size') {
      let items = legend.selectAll('.legend-item').data(legendData)
      let itemsEnter = items
        .enter()
        .append('div')
        .attr('class', 'legend-item')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('margin', '5px')
      items.exit().remove()

      itemsEnter.append('div').attr('class', 'icon').style('width', '10px').style('height', '10px')

      itemsEnter.append('div').attr('class', 'label').style('font-size', '14px')
      items = items.merge(itemsEnter)

      items.select('.label').text(d => d.id)
      items
        .select('.icon')
        .style('margin', '6px 8px 4px 4px') //este 6px, es porque la fuente no esta "bien centrada"
        .transition()
        .style('background', '#ddd')

      items
        .select('.icon')
        .classed('circle', true)
        .style('width', d => d.value + 'px')
        .style('height', d => d.value + 'px')
        .style('border-radius', d => d.value + 'px')
    }
  }

  let legendDatas = (chart.getLegendData && chart.getLegendData()) || chart.data
  if (Array.isArray(legendDatas))
    legendDatas = [{ id: chart.config.ItemsHelper.colorScale, data: legendDatas }]
  else
    legendDatas = Object.keys(legendDatas).map((key, i) => ({
      id: chart.config.ItemsHelper.colorScale[i] + '_' + key,
      data: legendDatas[key],
      __forceDraw__: legendDatas[key].__forceDraw__,
    }))
  legendDatas.forEach((ld, i) => {
    ld.type =
      ld.data.type || Array.isArray(chart.config.ItemsHelper.colorScale)
        ? chart.config.ItemsHelper.colorScale[i]
        : chart.config.ItemsHelper.colorScale
    ld.index = i
  })

  let legends = d3_select($root)
    .selectAll('.legend')
    .data(legendDatas, d => d.id)
  legends.exit().remove()
  let legendsEnter = legends.enter().append('div').attr('class', 'legend')
  legendsEnter.style('opacity', 0).transition().duration(1000).style('opacity', 1)
  legends = legends.merge(legendsEnter)
  legends
    .style('display', 'flex')
    .style('align-items', 'center')
    .style('margin', 'auto')
    .style('margin-top', '5px')
    .style('overflow-y', 'auto')
    .style('flex-wrap', 'nowrap')
    .style('max-width', '80vw')
    .style('padding-bottom', '10px')
  if (chart.config.lite) {
    legends.style('overflow', 'hidden')
    legends.style('padding', '0 10px')
    legendsEnter
      .selectAll('.scroll-btn')
      .data(['left', 'right'])
      .enter()
      .append('div')
      .attr('class', 'scroll-btn')

    legends
      .selectAll('.scroll-btn')
      .style('position', 'absolute')
      .style('left', d => (d === 'left' ? 0 : null))
      .style('right', d => (d === 'right' ? 0 : null))
      // .text(d => (d === 'left' ? '<' : '>'))
      .style('background-color', '#fff')
      .style('background-image', 'url(' + arrowIcon + ')')
      .style('background-position', 'right')
      .style('background-repeat', 'no-repeat')
      .style('background-size', 'contain')
      .style('width', '24px')
      .style('height', '18px')
      .style('transform', d => d === 'left' && 'rotate(180deg)')
      .style('cursor', 'pointer')

      .on('click', (e, d) => {
        // legends.node().scrollLeft += d === 'left' ? -20 : 20
        let left = legends.node().scrollLeft + (d === 'left' ? -120 : 120)

        legends.node().scroll({
          left: left,
          behavior: 'smooth',
        })
        legends
          .selectAll('.scroll-btn')
          .style('opacity', d => opacityCheck(legends.node(), d, left))
      })
  }

  legends.each(function (d) {
    drawLegend(d3_select(this), d)

    d3_select(this)
      .selectAll('.scroll-btn')
      .style('display', this.clientWidth < this.scrollWidth ? 'block' : 'none')
      .style('opacity', d => opacityCheck(this, d, 0))
  })
}

LegendBehavior.defaultConfig = {
  index: 201,
  /**
   * Show or hide the legend of the chart.
   */
  showLegend: {
    type: Boolean,
    default: true,
    exposed: true,
  },
  icon: {
    type: [String],
    options: ['square', 'circle', 'line'],
    default: 'square',
  },
}
LegendBehavior.configName = 'LegendBehavior'

export default LegendBehavior
